// extracted by mini-css-extract-plugin
export default {"main":"alsoBought_main__vjw4w"};